import React from 'react';
import { ResultProps } from '../components/types';
import StyleResult from '../components/StyleResult' 
import { Badge, Button, Card, Col, Container, ProgressBar, Row, Table } from 'react-bootstrap';
import AttributeCloud from '../components/AttributeCloud';


 const wording = {
      OPENNESS : {
        lowTitle : "Low Openness",
        lowSubTitle : "Consistent",
        lowAttributes : ["- Practical","- Conventional","- Prefers routine", "- Consistent"],
        highTitle : "High Openness",
        highSubTitle : "Inventive",
        highAttributes : ["- Curious","- Inventive","- Wide range of interest"],
      },
      CONSCIENTIOUSNESS : {
        lowTitle : "Low Conscientiousness",
        lowSubTitle : "Easygoing",
        lowAttributes : ["- Impulsive","- Careless","- Disorganized","- Easygoing"],
        highTitle : "High Conscientiousness",
        highSubTitle : "Efficient",
        highAttributes : ["- Dependable","- Organized","- Efficient","- Hard working"],
      },
      EXTROVERSION : {
        lowTitle : "Low Extroversion",
        lowSubTitle : "Reserved",
        lowAttributes : ["- Quiet","- Reserved","- Withdrawn"],
        highTitle : "High Extroversion",
        highSubTitle : "Energetic",
        highAttributes : ["- Outgoing","- Warm","- Energetic","- Seek Adventure"],
      },
      AGREEABLENESS : {
        lowTitle : "Low Agreeableness",
        lowSubTitle : "Detached",
        lowAttributes : ["- Critical","- Uncooperative","- Suspicious","- Detached"],
        highTitle : "High Agreeableness",
        highSubTitle : "Compassionate",
        highAttributes : ["- Helpful","- Trusting","- Empathetic","- Compassionate"],
      },
      NERVOSITY : {
        lowTitle : "Low Nervosity",
        lowSubTitle : "Confident",
        lowAttributes : ["- Calm","- Tempered","- Secured","- Confident"],
        highTitle : "High Nervosity",
        highSubTitle : "Sensitive",
        highAttributes : ["- Sensitive","- Anxious","- Prone to negative emotions"],
      }
    }

  function lowMediumHigh(score : number){
    if (score >= 55) {
      return "high"
    } 
    if (score <= 45){
      return "low"
    }
    return "medium"
  }

  function Result(props : ResultProps) {

    const chartData = [
      {style: 'O', score: props.quizResult.OPENNESS},
      {style: 'C', score: props.quizResult.CONSCIENTIOUSNESS},
      {style: 'E', score: props.quizResult.EXTROVERSION},
      {style: 'A', score: props.quizResult.AGREEABLENESS},
      {style: 'N', score: props.quizResult.NERVOSITY}          
    ];

    return (
      <div id="myres"  className="masthead">
          <h1>Your OCEAN Personality Traits</h1>
 
          <br />
          <p>Dear {props.username},</p>
          <p>Thank you for taking your OCEAN Personality Assessment! This is your first step towards
          increasing your self-awareness and personal effectiveness.</p>
          <p>This report will provide you insights about who you are, as well as areas where you can
          stretch yourself further, based on your answers. Self-awareness is crucial in our lives,
          because the better we understand ourselves, the more we can identify our personal blindspots
          and address them.</p>
          <p>I believe that growing as a person, both at home and at work, requires us to leverage our
          strengths. Once we know them, we can communicate them with our managers, colleagues,
          families and friends, asking them how they can help you to leverage them, for everyone’s
          benefit.</p>
          <p>This OCEAN Personality Report will also inform you about areas which may not be your
          strong suit. Ideally, your team and the people close to you can help you overcome them, by
          taking over them, or by creating systems which will allow you to forget them, and to focus on
          your strengths.</p>
          <p>It will take you through the five traits of the OCEAN Personality Model, highlighting where you
          stand on the spectrum, based on your answers. Each trait will shortly explain:</p>
          
          <ul>
            <li>Tendencies you may usually have</li>
            <li>How others may perceive you</li>
            <li>Examples of Personality Traits mismatches</li>
            <li>How to work well with different Personality Traits</li>
            <li>Questions to assess each Personality Trait</li>
          </ul>
          
          <div className="notabene">
          <p><b>It is crucial to understand that there is no "better than". “High” is not better than “Low”, and vice versa.</b></p>
          <p><b>What matters is understanding how our differences enrich us, rather than how they limit us.</b></p>
          <p><b>How they make us stronger, together</b></p>
          </div>

        
        <h2>Your Big Five Traits At A Glance</h2>
        <p className="text-center"><b>Please note that clicking any of the traits will take you directly to its description!</b></p>

          <Container>
          <Row className="my-report-row mb-3">
            <Col className="my-report-col-title round"><h3 className="myreporth3 round"><a href="#Otitle" className="report-btn-a">O</a></h3></Col>
            <Col className="col-10"><ProgressBar className="reportprogressbar" now={props.quizResult.OPENNESS} label={`${props.quizResult.OPENNESS}%`}/></Col>
          </Row>

          <Row className="my-report-row mb-3">
            <Col className="my-report-col-title"><h3 className="myreporth3"><a href="#Ctitle" className="report-btn-a">C</a></h3></Col>
            <Col className="col-10"><ProgressBar className="reportprogressbar" now={props.quizResult.CONSCIENTIOUSNESS} label={`${props.quizResult.CONSCIENTIOUSNESS}%`} /></Col>
          </Row>
          
          <Row className="my-report-row mb-3">
            <Col className="my-report-col-title"><h3 className="myreporth3"><a href="#Etitle" className="report-btn-a">E</a></h3></Col>
            <Col className="col-10"><ProgressBar className="reportprogressbar" now={props.quizResult.EXTROVERSION} label={`${props.quizResult.EXTROVERSION}%`} /></Col>
          </Row>

          <Row className="my-report-row mb-3">
            <Col className="my-report-col-title"><h3 className="myreporth3"><a href="#Atitle" className="report-btn-a">A</a></h3></Col>
            <Col className="col-10"><ProgressBar className="reportprogressbar" now={props.quizResult.AGREEABLENESS} label={`${props.quizResult.AGREEABLENESS}%`} /></Col>
          </Row>

          <Row className="my-report-row mb-3">
            <Col className="my-report-col-title"><h3 className="myreporth3"><a href="#Ntitle" className="report-btn-a">N</a></h3></Col>
            <Col className="col-10"><ProgressBar className="reportprogressbar" now={props.quizResult.NERVOSITY} label={`${props.quizResult.NERVOSITY}%`} /></Col>
          </Row>

          </Container>
          

        <section className="attributecloud">
        <AttributeCloud quizResult={props.quizResult} username={props.username}/>
        </section>
       
        <h2 id="Otitle">Your Openness To Experience</h2>
        <StyleResult style='Openness' score={props.quizResult.OPENNESS} wording={wording.OPENNESS}/>

        <h2 id="Ctitle">Your Conscientiousness</h2>
        <StyleResult style='Conscientiousness' score={props.quizResult.CONSCIENTIOUSNESS} wording={wording.CONSCIENTIOUSNESS}/>

        <h2 id="Etitle">Your Extroversion</h2>
        <StyleResult style='Extroversion' score={props.quizResult.EXTROVERSION} wording={wording.EXTROVERSION}/>
       
        <h2 id="Atitle">Your Agreeableness</h2>
        <StyleResult style='Agreeableness' score={props.quizResult.AGREEABLENESS} wording={wording.AGREEABLENESS}/>
       
        <h2 id="Ntitle">Your Nervosity</h2>
        <StyleResult style='Nervosity' score={props.quizResult.NERVOSITY} wording={wording.NERVOSITY}/>
        <br /> <br /><br />
      </div>
    );
  }
  export default Result;

/*    AGREEABLENESS: float
  CONSCIENTIOUSNESS: float
  EXTROVERSION: float
  NERVOSITY: float
  : float*/
